export const API_ROOT = './static'
export const API_NPB_LEAGUES = `${API_ROOT}/npb-leagues.json`
export const API_NPB_TEAMS = `${API_ROOT}/npb-teams.json`
export const API_NUMBER_OF_VISITORS_HISTORY = `${API_ROOT}/npb-number-of-visitors-history.json`
export const API_PENNANT_RACE_HISTORY = `${API_ROOT}/npb-pennant-race-history.json`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/api/endpoints.ts